import React from 'react';
import { Route } from 'react-router-dom';

// import history from '@utils/history';
// import { getAccessToken } from '@utils/storage';

function RequireAuthRoute(props: any) {
  const { component: Component, ...rest } = props;
  // const auth = getAccessToken();
  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (Component) {
          return <Component {...matchProps} />;
        }
        // history.replace(`/sign-in?fallbackUrl=${matchProps.location.pathname}`);
        return null;
      }}
    />
  );
}

export default RequireAuthRoute;
